import { call, fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/consideration';
import { listNavigator } from 'sagas/common';
import { loadSingleData } from 'sagas/common';
import { actions as customerAction } from 'domain/customer';
import filters from 'filters/consideration';

export default function* navigator({ params: { userId: id } }) {
  if (id) yield call(loadSingleData, { modelName: 'Customer', actions: customerAction, id, initForm: false });
  yield fork(listNavigator, { modelName: 'Consideration', actions, selectors, filters } );
}
